// keep this consistent with backend constants.go
export enum FeatureKeys {
	SSO = 'SSO',
	USE_SPAN_METRICS = 'USE_SPAN_METRICS',
	ONBOARDING = 'ONBOARDING',
	CHAT_SUPPORT = 'CHAT_SUPPORT',
	GATEWAY = 'GATEWAY',
	PREMIUM_SUPPORT = 'PREMIUM_SUPPORT',
	ANOMALY_DETECTION = 'ANOMALY_DETECTION',
	ONBOARDING_V3 = 'ONBOARDING_V3',
	TRACE_FUNNELS = 'TRACE_FUNNELS',
}
